import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {
  Details,
  KpisPopover,
  ChartsPopover,
} from "../DatastoryCreate/DatastoryCreateHelpers";
import {
  wrapperDatastory,
  getInitialDsForm,
  getInitialDsStepper,
  validateDsForm,
  unwrapperChartsPopoverData,
  unwrapperChartsPopoverSelections,
} from "../../../utils/dsUtils";
import { unwrapperChartObject } from "../../../utils/chartObjectUtils";
import { useContext, useEffect, useReducer, useState } from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import SigviewStepper from "../../../components/SigviewStepper";
import useReducerLogger from "../../../utils/useReducerLogger";
import standaloneDsReducer from "../../../redux/reducers/standaloneDs";
import SigviewButton from "../../../components/Common/SigviewButton";
import { masterTrackGaEvent } from "../../../services/ga";
import {
  updateStandaloneDsForm,
  updateUserScreen,
  updateStandaloneDsFormMultipleKpis,
  updateStandaloneDsFormMultipleCharts,
  updateTimeFiltersWithDefaultDates,
  updateGlobalFiltersDimensionFilters,
  updateGlobalFiltersTimeFilters,
  updateGlobalFiltersFormAnalyzeFiltersReadOnly,
} from "../../../redux/actions";
import { getChartObjectList, saveDs, updateDs } from "../../../services/api";
import { ThemeContext } from "../../../contexts/ThemeContext";
import orderBy from "lodash.orderby";
import { config } from "../../../config/config";
import allTimezones from "../../../../assets/data/allTimezones.json";
import allDatePresets from "../../../../assets/data/allDatePresets.json";
import timeFiltersReducer from "../../../redux/reducers/timeFilters";
import useUpdateEffect from "../../../hooks/useUpdateEffect";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    height: "85%",
    width: "90%",
    maxHeight: "800px",
    maxWidth: "1200px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "15px",
    boxShadow: theme.shadows[5],
    boxSizing: "border-box",
    padding: theme.spacing(2, 4, 3),
  },
  root: {
    width: "100%",
    "& > .MuiStepper-root": {
      padding: "10px 0px",
    },
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const initialData = { status: "loading", message: "", data: [] };

function DatastoryCreateModal(props) {
  const classes = useStyles();
  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];
  const {
    dispatch: ReduxDispatcher,
    user,
    allData,
    globalFilters = {},
    open,
    handleClose,
  } = props;
  const getInitialDsFormProps = {
    user,
    allData,
    title: user.screen.activeDatastory.title,
  };
  // console.log("user.screen
  const initialDsForm = getInitialDsForm(getInitialDsFormProps);
  const pathname = window.location.pathname;
  const rootPage = pathname.split("/")[1];

  initialDsForm.dimensionFilters = {
    ...initialDsForm.dimensionFilters,
    value: globalFilters.dimensionFilters,
  };

  initialDsForm.timeFilters = {
    ...initialDsForm.timeFilters,
    value: globalFilters.timeFilters,
  };

  initialDsForm.rollingDateType = {
    ...initialDsForm.rollingDateType,
    value: globalFilters.analyzeFiltersReadOnly.rollingDateType.value,
  };
  const [dsForm, dispatchDsForm] = useReducer(
    useReducerLogger(standaloneDsReducer),
    initialDsForm
  );
  const initialDsStepper = getInitialDsStepper(
    user.screen.activeDatastory.elementType
  );
  const [stepperState, setStepperState] = useState(initialDsStepper);
  const [savedCharts, setSavedCharts] = useState(initialData);
  const [reloadSavedCharts, setReloadSavedCharts] = useState(false);

  const history = useHistory();

  useEffect(() => {
    return () => {
      // Revert to inital state in redux when component unmounts
      // This is to cater to case when user switches between tabs
      ReduxDispatcher(updateGlobalFiltersFormAnalyzeFiltersReadOnly());
    };
  }, []);

  useUpdateEffect(() => {
    if (dsForm.dimensionFilterType.value === "widget") {
      let payload = { value: [] };
      let action = updateGlobalFiltersDimensionFilters(payload);
      ReduxDispatcher(action);
    } else if (dsForm.dimensionFilterType.value === "dashboard") {
      let payload = { value: dsForm.dimensionFilters.value };
      let action = updateGlobalFiltersDimensionFilters(payload);
      ReduxDispatcher(action);
    }
  }, [dsForm.dimensionFilterType.value, savedCharts]);

  useUpdateEffect(() => {
    if (dsForm.timeFilterType.value === "widget") {
      const calendarDaysLimits = user.uiLimitsList.daysLimitCalendarDashboard;
      const timeFiltersAction = updateTimeFiltersWithDefaultDates({
        selectedTimezone: allTimezones[1],
        startDateEpoch: allData.dateRange.data.startDate,
        endDateEpoch: allData.dateRange.data.endDate,
        allDatePresets,
        format: config.hardCoded.datetimeFormat,
        selectedDatePreset: "last_2_days",
        daysLimit: calendarDaysLimits,
        isComparisonOn: false,
      });
      const defaultTimeFilters = timeFiltersReducer({}, timeFiltersAction);
      let payload = { value: defaultTimeFilters };
      var action = updateGlobalFiltersTimeFilters(payload);
      ReduxDispatcher(action);
    } else if (dsForm.timeFilterType.value === "dashboard") {
      let payload = { value: dsForm.timeFilters.value };
      var action = updateGlobalFiltersTimeFilters(payload);
      ReduxDispatcher(action);
    }
  }, [dsForm.timeFilterType.value, savedCharts]);

  //Defining required useEffects
  useEffect(() => {
    //Make fetch call using axios
    const source = axios.CancelToken.source();
    const fetchProps = {
      cancelToken: source.token,
    };
    const getChartObjectListPromise = getChartObjectList(fetchProps);
    getChartObjectListPromise
      .then((responseData) => {
        let newData = {
          status: "success",
          message:
            responseData?.result?.data?.length || [].length !== 0
              ? ""
              : "No charts to display",
          data: config.hardCoded.convertAllTablesToMultiTable(
            responseData?.result?.data || []
          ),
        };
        setSavedCharts(newData);
      })
      .catch((json) => {
        if (json.error !== config.hardCoded.queryCancelled) {
          let newData = { status: "error", message: json.error, data: [] };
          setSavedCharts(newData);
          console.groupCollapsed("UI ERROR");
          console.log("ERROR ->", json.error);
          console.groupEnd();
        }
      });

    return () => {
      setSavedCharts(initialData);
      //Cancel all previous fetch calls
      if (source) source.cancel();
    };
  }, [reloadSavedCharts]);

  const handleStepperChange = (stepperState) => {
    setStepperState(stepperState);
  };
  function validateCurrentStep(state, payload) {
    const { activeStep } = state;

    const { form } = payload;
    return { flag: true, message: "" };
  }
  const handleDsFormChange = (key, value) => {
    const payload = { key, value };
    const action = updateStandaloneDsForm(payload);
    dispatchDsForm(action);
    var payloadData = { value: value };
    if (key === "dimensionFilters") {
      var actionDimFilter = updateGlobalFiltersDimensionFilters(payloadData);
      ReduxDispatcher(actionDimFilter);
    } else if (key === "timeFilters") {
      var actionTimeFilter = updateGlobalFiltersTimeFilters(payloadData);
      ReduxDispatcher(actionTimeFilter);
    }
  };
  const handleSavedChartsReload = () =>
    setReloadSavedCharts(!reloadSavedCharts);
  const handleSaveAndLaunch = () => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "CreateDatastory",
      action: "Launch",
      label: "Save",
    });
    let backendDs = wrapperDatastory({ uiDs: dsForm, user });
    backendDs = { ...backendDs };
    const fetchProps = {
      payload: { ...backendDs },
    };
    // Add Dashboard Loader
    var action = updateUserScreen("isDashboardLoading", true);
    ReduxDispatcher(action);
    const saveDsPromise = saveDs(fetchProps);
    saveDsPromise
      .then(() => {
        // // Remove Dashboard Loader
        // var action = updateUserScreen("isDashboardLoading", false);
        // ReduxDispatcher(action);

        // // Update snackbar
        const snackbarPayload = {
          ...user.screen.snackbar,
          open: true,
          message: "Datastory saved successfully!",
        };
        // var action = updateUserScreen("snackbar", snackbarPayload);
        // ReduxDispatcher(action);

        // Remove Dashboard Loader
        const value = {
          isDashboardLoading: false,
          snackbar: snackbarPayload,
          activeNav: "datastory",
          activeTab: "dashboard",
          activeDsCategory: "saved",
          activeDatastory: {
            ...backendDs,
            dsCategory: "Saved",
            elementType: "edit",
          },
        };
        const action = updateUserScreen(null, value);
        ReduxDispatcher(action);
        history.push("/datastory/dashboard");
      })
      .catch((json) => {
        console.groupCollapsed("API FAILED");
        console.log("Error JSON -> ", json);
        console.groupEnd();
        const message = json.error || "Datastory saved failed";

        // Remove Dashboard Loader
        var action = updateUserScreen("isDashboardLoading", false);
        ReduxDispatcher(action);

        // Update snackbar
        const snackbarPayload = {
          ...user.screen.snackbar,
          open: true,
          message: message,
        };
        var action = updateUserScreen("snackbar", snackbarPayload);
        ReduxDispatcher(action);
      });
  };
  const handleUpdateAndLaunch = () => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "EditDatastory",
      action: "Launch",
      label: "Update",
    });
    let backendDs = wrapperDatastory({ uiDs: dsForm, user });
    backendDs = { ...backendDs };
    const fetchProps = {
      payload: { ...backendDs },
    };
    // Add Dashboard Loader
    var action = updateUserScreen("isDashboardLoading", true);
    ReduxDispatcher(action);
    const updateDsPromise = updateDs(fetchProps);
    updateDsPromise
      .then(() => {
        const snackbarPayload = {
          ...user.screen.snackbar,
          open: true,
          message: "Datastory updated successfully!",
        };
        const value = {
          isDashboardLoading: false,
          snackbar: snackbarPayload,
          activeNav: "datastory",
          activeTab: "dashboard",
          activeDsCategory: "saved",
          activeDatastory: {
            ...backendDs,
            dsCategory: "Saved",
            elementType: "edit",
          },
        };
        const action = updateUserScreen(null, value);
        ReduxDispatcher(action);
        history.push("/datastory/dashboard");
      })
      .catch((json) => {
        console.groupCollapsed("API FAILED");
        console.log("Error JSON -> ", json);
        console.groupEnd();
        const message = json.error || "Datastory update failed";

        // Remove Dashboard Loader
        var action = updateUserScreen("isDashboardLoading", false);
        ReduxDispatcher(action);

        // Update snackbar
        const snackbarPayload = {
          ...user.screen.snackbar,
          open: true,
          message: message,
        };
        var action = updateUserScreen("snackbar", snackbarPayload);
        ReduxDispatcher(action);
      });
  };
  const handleKpisChange = (event, modifiedKpis) => {
    // * This reducer case is using allData and utility functions which might throw an error
    // * Hence this catch block
    try {
      const calendarDaysLimits = user.uiLimitsList.daysLimitCalendarDashboard;
      const timeFiltersAction = updateTimeFiltersWithDefaultDates({
        selectedTimezone: allTimezones[1],
        startDateEpoch: allData.dateRange.data.startDate,
        endDateEpoch: allData.dateRange.data.endDate,
        allDatePresets,
        format: config.hardCoded.datetimeFormat,
        selectedDatePreset: "last_2_days",
        daysLimit: calendarDaysLimits,
        isComparisonOn: false,
      });
      const defaultTimeFilters = timeFiltersReducer({}, timeFiltersAction);
      const payload = { modifiedKpis, allData, defaultTimeFilters };
      const action = updateStandaloneDsFormMultipleKpis(payload);
      dispatchDsForm(action);
    } catch (error) {
      console.error("UI ERROR");
      console.groupCollapsed("DETAILS");
      console.log(error);
      console.groupEnd();
    }
  };
  const handleChartsChange = (event, modifiedChartsIds) => {
    // Convert chartIds to proper ui selection objects
    let modifiedCharts = modifiedChartsIds.map((chartId) => {
      // console.log("chartId", chartId);
      // console.log("savedCharts.data", savedCharts.data);
      const backendChartObj = savedCharts.data.find(
        (savedChart) => savedChart._id === chartId
      );
      // console.log("backendChartObj", backendChartObj);
      if (backendChartObj) {
        var chartForUi = unwrapperChartObject({
          allData: allData,
          user: user,
          payload: { ...backendChartObj },
        });
        return chartForUi;
      } else if (crudType === "edit") {
        // In case of edit, savedCharts.data will never have that information,
        // That information will be present in dsForm.selectedCharts
        // So pick from there
        var chartForUi = dsForm.selectedCharts.value[chartId];
        if (chartForUi) return chartForUi;
      }
    });
    modifiedCharts = modifiedCharts.filter((row) => row !== undefined);

    // * This reducer case is using allData and utility functions which might throw an error
    // * Hence this catch block
    try {
      const payload = { modifiedCharts, allData };
      const action = updateStandaloneDsFormMultipleCharts(payload);
      dispatchDsForm(action);
    } catch (error) {
      console.error("UI ERROR");
      console.groupCollapsed("DETAILS");
      console.log(error);
      console.groupEnd();
    }
  };
  const crudType = user.screen.activeDatastory.elementType;
  const isPageCreate = crudType !== "edit";
  const plotlyMetricsMod = allData.plotlyMetrics.map((row) => ({
    id: row._id,
    name: row._title,
    disabled: false,
    checked: false,
  }));
  const orderedArray = orderBy(plotlyMetricsMod, "name");
  const { status: dsFormStatus, message: dsFormMessage } =
    validateDsForm(dsForm);
  const isSaveDisabled = dsFormStatus === "invalid";
  const actionButtonTitle = isPageCreate
    ? "Save and Launch"
    : "Update and Launch";
  const actionButtonOnClick = isPageCreate
    ? handleSaveAndLaunch
    : handleUpdateAndLaunch;

  const chartsPopoverDataProps = {
    dsForm,
    savedCharts,
    allData,
    user,
  };
  const chartsPopoverData = unwrapperChartsPopoverData(chartsPopoverDataProps);
  // B. chartsPopoverSelections
  const chartsPopoverSelectionsProps = {
    savedCharts,
    dsForm,
  };
  // console.log("dsForm.selectedCharts
  const chartsPopoverSelections = unwrapperChartsPopoverSelections(
    chartsPopoverSelectionsProps
  );

  const handleAddFilters = () => {
      const handleApplyFilters = (payload, filterType) => {
        // switch (filterType) {
        //   case "dimensions":
        //     var action = replaceAllDimensionFilters(payload);
        //     var newDimensionFilters = dimensionFiltersReducer(
        //       wsForm.dimensionFilters.value,
        //       action
        //     );
        //     handleDimensionFiltersChange(newDimensionFilters);
        //     break;
        //   // case "metrics":
        //   //   var action = replaceAllMetricFilters(payload);
        //   //   dispatchMetricFilters(action);
        //   //   break;
        //   // case "time":
        //   //   onTimeFiltersChange(payload);
        //   //   break;
        // }
      };
  
      // Google Analytics Event - Master
      masterTrackGaEvent({
        category: "GlobalFilters",
        action: "Open Filters",
        label: "Sidenav",
      });
      const commonGlobalFilterProps = {
        isOpen: true, //global filters dialog open close
        showTimeFilters: false,
        showMetricFilters: false,
        activeFilterType: "dimensions",
        isAdFiltersOpen: false, //advanced filters dialog open close
        timeFilters: user.timeFilters, //for initializing filters
        dimensionFilters: [], //for initializing filters
        metricFilters: [], //for initializing filters
        // settings: dimensionFiltersSettings,
        filtersDimData: allData.plotlyDimensions,
        filtersMetricsData: allData.plotlyMetrics,
        selections: {},
      };
      //Open Global Filters
      const newGlobalFiltersProps = {
        ...commonGlobalFilterProps,
        activeDimensionFilter: {},
        handleApplyFilters, //It will take 2 parameters, payload and filterType (dimensions or metric or time); We have 2 separate actions for both
      };
  
      const action = updateUserScreen("globalFilters", newGlobalFiltersProps);
      ReduxDispatcher(action);
    };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        disableEnforceFocus  
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h3
              id="transition-modal-title"
              style={{
                color: themeColors["secondaryColor"],
                fontSize: "20px",
                fontWeight: "500",
                marginBlock: "0.5em",
              }}
            >
              Create Datastory
            </h3>
            <section className="main-content-with-title">
              <SigviewStepper
                initialState={stepperState}
                form={dsForm}
                formValidator={validateCurrentStep}
                onChange={handleStepperChange}
                user={user}
                renderButton={() => (
                  <SigviewButton
                    disabled={isSaveDisabled}
                    onClick={actionButtonOnClick}
                    title={actionButtonTitle}
                    variant="containedPrimary"
                    customClassName={`datastory-${actionButtonTitle.replace(
                      / +/g,
                      ""
                    )}-GA`}
                    style={{
                        buttonHeight: "28px",
                        borderRadius: "999em",
                        padding: "10px 15px",
                    }}
                    iconFlag={true}
                    iconPosition="end" // "start" or "end"
                    iconProps={{
                        className: "material-icons-round",
                        iconName: "check_circle",
                    }}
                    iconStyle={{fontSize: "12px"}}
                  />
                )}
              >
                <Details
                  dsForm={dsForm}
                  handleDsFormChange={handleDsFormChange}
                  allData={allData}
                  globalFilters={globalFilters}
                  user={user}
                  ReduxDispatcher={ReduxDispatcher}
                  isEdit={crudType === "edit"}
                  className={`${rootPage}AddFilters-GA`}
                />
                <ChartsPopover
                  allData={allData}
                  user={user}
                  ReduxDispatcher={ReduxDispatcher}
                  themeColors={themeColors}
                  initialData={chartsPopoverData}
                  initialSelections={chartsPopoverSelections}
                  onChange={handleChartsChange}
                  handleReload={handleSavedChartsReload}
                  dsForm={dsForm}
                  crudType={crudType}
                />
                <KpisPopover
                  user={user}
                  allData={allData}
                  ReduxDispatcher={ReduxDispatcher}
                  initialData={orderedArray}
                  initialSelections={Object.keys(dsForm.selectedKpis.value)}
                  onChange={handleKpisChange}
                  settings={{ maxLimit: config.hardCoded.kpisMaxLimitInDs }}
                />
              </SigviewStepper>
            </section>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  allData: state.data,
  globalFilters: state.globalFilters,
});

export default connect(mapStateToProps)(DatastoryCreateModal);
